const config = (function () {
  return {
    API_ROOT: (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') ? process.env.BASE_API : "",
    BASE_URL: (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') ? process.env.BASE_API : "",
  }
})()

export default config



// WEBPACK FOOTER //
// ./src/utils/config.js